import React, { type FC } from 'react';
import { cn } from '../../utils/ui';

export interface CharacterCounterProps {
    className?: string;
    maxChars?: number;
    value: string;
}

const CharacterCounter: FC<CharacterCounterProps> = props => {
    const { className } = props;

    function getText(): string {
        const { value, maxChars } = props;
        if (!maxChars) return value;
        const length = value.length;
        return `${length}/${maxChars}`;
    }

    return (
        // font-mono - monospace font so each character in the counter will have the same width, thus preventing the text from shifting
        <span className={cn('font-mono', className)}>{getText()}</span>
    );
};

export default CharacterCounter;
